// extracted by mini-css-extract-plugin
export default {"modal":"EstudianteFiltroMenu_modal__ZAbFL","botok":"EstudianteFiltroMenu_botok__OR0PQ","contCheckboxes":"EstudianteFiltroMenu_contCheckboxes__3WfEk"};